// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2kkAd","name":"Header_name__33MHT","birthday":"Header_birthday__1_9WI","skeleton":"Header_skeleton__7dHDj"};